import IconButton from 'components/common/IconButton';
import { Card, Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useState } from 'react';
import ActionsModalProject from './ActionsModalProject';
import { TitleGenerator } from 'utils/TitleGenerator';
import ShareModalProject from './ShareModalProject';

const SelectBarProject = ({
  selected,
  setSelected,
  handleCheckbox,
  setCheckChanges
}) => {
  // * States
  const [showActiveModal, setShowActiveModal] = useState(false);
  const [showPauseModal, setShowPauseModal] = useState(false);
  const [showFinishModal, setShowFinishModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // modal de compartir honorarios
  const [showShareModal, setShowShareModal] = useState(false);

  // * Methods
  const GenerateLink = (id, title) =>
    `${process.env.REACT_APP_CLIENT_DETAIL_PROJECT}${id}/${TitleGenerator(
      title
    )}`;

  const HandleShare = () => {
    const subject = '🏡 Emprendimientos de su interés';

    const body =
      'Aquí te envío la lista de emprendimientos: \n\n' +
      selected
        .map(item => `${item.title} \n ${GenerateLink(item.id, item.title)}`)
        .join('\n\n');

    window.location.href = `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
  };

  return (
    <>
      {/* Select bar */}
      <Card className="mb-1 bg-white">
        <Card.Body>
          <Row>
            <Col xs={12} className="d-flex justify-content-between">
              <div className="d-flex align-items-center" style={{ gap: 10 }}>
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip>
                      {selected.length
                        ? 'Deseleccionar todos'
                        : 'Seleccionar todos'}
                    </Tooltip>
                  }
                >
                  <Form.Check
                    type="checkbox"
                    onChange={handleCheckbox}
                    checked={!!selected.length}
                  />
                </OverlayTrigger>

                {/* Publish */}
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Activar</Tooltip>}
                >
                  <span>
                    <IconButton
                      buttonSize="sm"
                      style={{ width: 30 }}
                      icon="play"
                      onClick={() => setShowActiveModal(true)}
                      variant="light"
                      className="px-2"
                      disabled={selected.length === 0}
                    />
                  </span>
                </OverlayTrigger>

                {/* Pause */}
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Pausar</Tooltip>}
                >
                  <span>
                    <IconButton
                      buttonSize="sm"
                      style={{ width: 30 }}
                      icon="fa-pause"
                      onClick={() => setShowPauseModal(true)}
                      variant="light"
                      className="px-2"
                      disabled={selected.length === 0}
                    />
                  </span>
                </OverlayTrigger>

                {/* Finish */}
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Finalizar</Tooltip>}
                >
                  <span>
                    <IconButton
                      buttonSize="sm"
                      style={{ width: 30 }}
                      icon="flag-checkered"
                      onClick={() => setShowFinishModal(true)}
                      variant="light"
                      className="px-2"
                      disabled={selected.length === 0}
                    />
                  </span>
                </OverlayTrigger>

                {/* Delete */}
                <OverlayTrigger
                  placement={'bottom'}
                  overlay={<Tooltip>Eliminar</Tooltip>}
                >
                  <span>
                    <IconButton
                      buttonSize="sm"
                      style={{ width: 30 }}
                      icon="trash-can"
                      onClick={() => setShowDeleteModal(true)}
                      variant="light"
                      className="px-2"
                      disabled={selected.length === 0}
                    />
                  </span>
                </OverlayTrigger>

                {/* Email Share */}
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Compartir por correo</Tooltip>}
                >
                  <span>
                    <IconButton
                      buttonSize="sm"
                      style={{ width: 30 }}
                      icon="envelope"
                      onClick={HandleShare}
                      variant="light"
                      className="px-2"
                      disabled={selected.length === 0}
                    />
                  </span>
                </OverlayTrigger>

                {/* Share */}
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Compartir honorarios</Tooltip>}
                >
                  <span>
                    <IconButton
                      buttonSize="sm"
                      style={{ width: 30 }}
                      icon="share"
                      onClick={() => setShowShareModal(true)}
                      variant="light"
                      className="px-2"
                      disabled={selected.length === 0}
                    />
                  </span>
                </OverlayTrigger>
              </div>
              <div>
                <span>
                  {selected.length}{' '}
                  {selected.length === 1 ? 'seleccionado' : 'seleccionados'}
                </span>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Modals */}

      {/* Pause Modal */}
      {showPauseModal && (
        <ActionsModalProject
          selected={selected}
          setSelected={setSelected}
          setShow={setShowPauseModal}
          setCheckChanges={setCheckChanges}
          status="paused"
          actionName="pausados"
          modalMsg="se pausarán y los clientes ya no podrán verlos ni consultar por ellos."
          actionTitle="Pausar"
        />
      )}

      {/* Active Modal */}
      {showActiveModal && (
        <ActionsModalProject
          selected={selected}
          setSelected={setSelected}
          setShow={setShowActiveModal}
          setCheckChanges={setCheckChanges}
          status="published"
          actionName="activados"
          modalMsg="se activarán y los clientes podrán verlos y consultar por ellos."
          actionTitle="Activar"
        />
      )}

      {/* Finish Modal */}
      {showFinishModal && (
        <ActionsModalProject
          selected={selected}
          setSelected={setSelected}
          setShow={setShowFinishModal}
          setCheckChanges={setCheckChanges}
          status="finished"
          actionName="finalizados"
          modalMsg="se finalizarán y se marcarán como una operación realizada."
          actionTitle="Finalizar"
        />
      )}

      {/* Delete Modal */}
      {showDeleteModal && (
        <ActionsModalProject
          selected={selected}
          setSelected={setSelected}
          setShow={setShowDeleteModal}
          setCheckChanges={setCheckChanges}
          status="deleted"
          actionName="eliminados"
          modalMsg="se eliminarán. Se marcarán como operación no concretada y los clientes no podrán verlos."
          actionTitle="Eliminar"
        />
      )}

      {/* Share Modal */}
      {showShareModal && (
        <ShareModalProject
          selected={selected}
          setSelected={setSelected}
          setShow={setShowShareModal}
          setCheckChanges={setCheckChanges}
        />
      )}
    </>
  );
};

SelectBarProject.propTypes = {
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired,
  handleCheckbox: PropTypes.func.isRequired,
  setCheckChanges: PropTypes.func.isRequired
};

export default SelectBarProject;
